import I18n from 'I18n';
import Small from 'UIComponents/elements/Small';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import * as AuditEventTypes from 'automation-ui-management/records/AuditHistory/AuditEventTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AuditEventRowMicrocopy = ({
  auditEvent
}) => {
  if (auditEvent.getAuditEventType() === AuditEventTypes.ACTION_MODIFICATION) {
    const auditEventActionMetadata = auditEvent.getAuditEventActionMetadata();
    const actionsAdded = auditEventActionMetadata.getAddedCount();
    const actionsEdited = auditEventActionMetadata.getEditedCount();
    const actionsDeleted = auditEventActionMetadata.getDeletedCount();
    const microcopy = [];
    if (actionsAdded > 0) {
      microcopy.push(I18n.text('automation-ui-management.auditEvent.auditEventSubTypes.ACTION_MODIFICATION.ADDED_ACTION', {
        count: actionsAdded
      }));
    }
    if (actionsEdited > 0) {
      microcopy.push(I18n.text('automation-ui-management.auditEvent.auditEventSubTypes.ACTION_MODIFICATION.EDITED_ACTION', {
        count: actionsEdited
      }));
    }
    if (actionsDeleted > 0) {
      microcopy.push(I18n.text('automation-ui-management.auditEvent.auditEventSubTypes.ACTION_MODIFICATION.DELETED_ACTION', {
        count: actionsDeleted
      }));
    }
    return /*#__PURE__*/_jsx(Small, {
      children: microcopy.join(', ')
    });
  }
  const enrollExistingDecision = auditEvent.getEnrollExistingDecision();
  const associatedBulkEnrollment = auditEvent.getAssociatedBulkEnrollment();
  if (enrollExistingDecision !== 'NOT_APPLICABLE') {
    const objectTypeId = auditEvent.getFirstRevision().flow.objectTypeId;
    let enrolledExistingStatusMessage = null;
    if (associatedBulkEnrollment) {
      if (associatedBulkEnrollment.bulkProcessingState === 'PROCESSING' || associatedBulkEnrollment.bulkProcessingState === 'ENQUEUED') {
        enrolledExistingStatusMessage = /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-management.auditEvent.auditEventSubTypes.OBJECTS_BULK_ENROLLED.PROCESSING_cob",
          objectTypeId: objectTypeId
        });
      } else {
        const objectsEnrolled = I18n.formatNumber(associatedBulkEnrollment.size || 0);
        enrolledExistingStatusMessage = /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: associatedBulkEnrollment.size === 0 ? 'automation-ui-management.auditEvent.auditEventSubTypes.OBJECTS_BULK_ENROLLED.completedNone_cob' : 'automation-ui-management.auditEvent.auditEventSubTypes.OBJECTS_BULK_ENROLLED.completedSome_cob',
          objectTypeId: objectTypeId,
          options: {
            count: objectsEnrolled
          }
        });
      }
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: enrollExistingDecision === 'DID_NOT_ENROLL' ? 'automation-ui-management.auditEvent.auditEventSubTypes.OBJECTS_BULK_ENROLLED.didNotEnrollHeader_cob' : 'automation-ui-management.auditEvent.auditEventSubTypes.OBJECTS_BULK_ENROLLED.enrolledHeader_cob',
          objectTypeId: objectTypeId
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Small, {
          children: [enrolledExistingStatusMessage, " "]
        })
      })]
    });
  }
  return null;
};
export default AuditEventRowMicrocopy;